export const ORIENTATIONS_COUNT = 4;
export const PHOTO_INPUT_NAME = 'image';
